import React from 'react';
import { Row, Col, Container } from '@everlywell/leaves';
import * as S from './styles';
import { IResource, RESOURCES_TYPES } from 'utils/types';
import { generateKey } from 'utils/helpers';

export interface IHeaderSection {
  headline: string;
  backgroundColor: string;
  slug?: string;
  resources?: IResource[];
}

export const HeaderSection: React.FC<IHeaderSection> = ({
  headline,
  backgroundColor,
  slug = 'headerSection',
  resources,
}) => {
  return (
    <S.SectionWrapper
      data-testid="HeaderSection"
      id={slug}
      backgroundColor={backgroundColor}
    >
      <Container>
        <Row center="xs">
          <Col xs={12}>
            <S.SectionHeadline>{headline}</S.SectionHeadline>
          </Col>
        </Row>
        <S.CardContainer>
          <Row center="xs">
            {resources?.length
              ? resources.map((content) => (
                  <Col sm={12} md={6} key={generateKey()}>
                    <S.ImageCard
                      type={content.type}
                      heading={content.title || ''}
                      content={content.summary?.summary || ''}
                      // link page url with slug
                      cta={{
                        ...content.cta,
                        url:
                          content.type === RESOURCES_TYPES.WHITE_PAPER
                            ? content.cta.url
                            : content.slug
                            ? `/resources/${content.slug}`
                            : `/resources/${content.cta?.url}`,
                      }}
                      image={content.image}
                      key={generateKey()}
                    />
                  </Col>
                ))
              : null}
          </Row>
        </S.CardContainer>
      </Container>
    </S.SectionWrapper>
  );
};

export default HeaderSection;
